module.exports = "../dist/img/product-detail-1-39.8743.jpg";